/* Bonne Manière · note Openreviews avec repli Trustpilot (snippets/bm-openreviews.liquid).
   [data-bm-or="stars"]       : note du produit (data-pid) « ★ 4,5 (78 avis) », clic = défile vers les avis du bas.
   [data-bm-or="header-line"] : widget Openreviews « header-line » (note boutique).
   Moins de MIN_REVIEWS avis Openreviews (produit non couvert, analyse en cours, erreur) ou note produit < MIN_AVG → TrustBox Trustpilot du <template>. */
(function () {
  if (window.__bmOr) { window.__bmOr(); return; }
  var TENANT = 'pk_live_c2b940196b8e9ee4c74eba2d8c1eb315bd1406a8b831b3bf';
  var API = 'https://api.openreviews.io/v1/augur/';
  var MIN_REVIEWS = 5; /* note du haut : en dessous, Trustpilot (décision du 21/10/2026) */
  var MIN_FEED = 1;    /* bloc du bas : affiché dès 1 avis s'il a du contenu (Openreviews a retiré son seuil de 5 avis écrits, 30/10/2026) */
  var MIN_AVG = 4.2;   /* note produit sous 4,2 : ni étoiles ni bloc Openreviews, Trustpilot à la place (décision Fabien) */
  /* Origine des avis (obligation d'information, Code conso L111-7-2 / D111-17) ; « vérifiés » confirmé par Openreviews le 27/10/2026 */
  var TP_URL = 'https://fr.trustpilot.com/review/bonnemaniere.fr';
  var MENTION_HTML = 'Note moyenne calculée à partir des avis clients vérifiés publiés sur des sites marchands de référence pour ce modèle. ' +
    'Ces avis portent sur le produit ; pour votre expérience Bonne Manière, consultez nos <a href="' + TP_URL + '" target="_blank" rel="noopener">avis Trustpilot</a>.';
  var cache = {};

  function getJson(key, url, pick) {
    if (!cache[key]) {
      cache[key] = fetch(url).then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .then(pick).catch(function () { return { n: 0 }; });
    }
    return cache[key];
  }
  function shopRating() {
    return getJson('shop', API + 'shop/reviews?tenant=' + TENANT + '&offset=0&limit=1&locale=fr', function (d) {
      return { n: d.total_reviews || 0, avg: d.avg_rating || 0 };
    });
  }
  function productRating(id) {
    return getJson('p' + id, API + 'synthesis?gtin=' + id + '&tenant=' + TENANT + '&locale=fr', function (d) {
      var ok = (d.state === 'ready' || d.state === 'no_summary') && (d.avg_rating || 0) >= MIN_AVG;
      /* detail : il y a quelque chose à lire en bas (synthèse ou avis écrits), pas seulement des notes */
      var detail = !!(d.summary || (d.text_reviews || 0) > 0 || (d.pros && d.pros.length));
      return ok ? { n: d.total_reviews || 0, avg: d.avg_rating || 0, detail: detail } : { n: 0 };
    });
  }

  function trustpilot(el) {
    var tpl = el.querySelector('template[data-bm-or-tp]');
    if (!tpl) return;
    el.appendChild(tpl.content.cloneNode(true));
    var box = el.querySelector('.trustpilot-widget');
    if (window.Trustpilot && window.Trustpilot.loadFromElement) {
      window.Trustpilot.loadFromElement(box, true);
    } else if (!window.__bmTp) {
      window.__bmTp = true;
      var sc = document.createElement('script');
      sc.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      sc.async = true;
      document.head.appendChild(sc);
    }
  }

  function stars(el, r) {
    var note = (Math.round(r.avg * 10) / 10).toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    var pct = Math.max(0, Math.min(100, r.avg / 5 * 100));
    var count = r.n.toLocaleString('fr-FR') + ' avis';
    var feedEl = document.querySelector('.bm-or--feed');
    var feedSec = feedEl && (feedEl.closest('.shopify-section') || feedEl);
    var hasFeed = !!(feedEl && r.detail && feedSec.style.display !== 'none');
    var b = document.createElement(hasFeed ? 'button' : 'div');
    b.className = 'bm-orstars' + (hasFeed ? '' : ' bm-orstars--static');
    if (hasFeed) { b.type = 'button'; b.setAttribute('aria-label', 'Note ' + note + ' sur 5, ' + count + '. Voir les avis'); }
    else { b.setAttribute('role', 'img'); b.setAttribute('aria-label', 'Note ' + note + ' sur 5, ' + count); }
    b.innerHTML = '<span class="bm-orstars__s" aria-hidden="true"><span style="width:' + pct + '%"></span></span>' +
      '<span class="bm-orstars__n">' + note + '</span><span class="bm-orstars__c">(' + count + ')</span>';
    var wrap = document.createElement('div');
    wrap.className = 'bm-orstars-wrap';
    var info = document.createElement('button');
    info.type = 'button';
    info.className = 'bm-orstars__info';
    info.setAttribute('aria-label', 'À propos de cette note');
    info.setAttribute('aria-expanded', 'false');
    info.textContent = 'i';
    var tip = document.createElement('div');
    tip.className = 'bm-orstars__tip';
    tip.setAttribute('role', 'note');
    tip.innerHTML = MENTION_HTML;
    info.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = wrap.classList.toggle('is-open');
      info.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) { wrap.classList.remove('is-open'); info.setAttribute('aria-expanded', 'false'); }
    });
    if (hasFeed) b.addEventListener('click', function () {
      /* défile sous l'en-tête fixe (sa hauteur varie selon l'écran et le défilement) */
      var feed = document.querySelector('.bm-or--feed');
      var sec = feed.closest('.shopify-section') || feed;
      var head = 0;
      document.querySelectorAll('header, .site-header, [data-section-type="header"], .bm-annbar').forEach(function (h) {
        var r = h.getBoundingClientRect(), pos = getComputedStyle(h).position;
        if ((pos === 'sticky' || pos === 'fixed') && r.bottom > head) head = r.bottom;
      });
      var y = sec.getBoundingClientRect().top + window.pageYOffset - Math.max(head, 80) - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
    wrap.appendChild(b);
    wrap.appendChild(info);
    wrap.appendChild(tip);
    el.appendChild(wrap);
  }

  function headerLine(el) {
    var sc = document.createElement('script');
    sc.src = 'https://api.openreviews.io/augur.js';
    sc.defer = true;
    sc.dataset.tenant = TENANT;
    sc.dataset.variant = 'header-line';
    sc.dataset.seo = 'off';
    el.appendChild(sc);
  }

  /* Avis du bas (widget « feed ») : « Synthèse Augur » → « Synthèse des avis », « Mis à jour il y a » masqué,
     « Propulsé par OpenReviews » gardé (contrat) mais tous les liens sortants du widget passent en nofollow (SEO),
     version compacte alignée sur la page : contenu pleine largeur à gauche, titre = titres de section du site
     (taille lue sur la page, donc juste à toutes les largeurs), texte 16 px, listes 14 px, jaune BM. */
  var FEED_CSS =
    '.air-eyebrow .air-mark{display:none!important}' +
    '.air-foot{font-size:12px!important;color:var(--bm-muted,#5e5b55)!important;margin-top:8px!important;margin-left:var(--bmo-col,0px)!important}' +
    '.air-augur{max-width:880px!important}.air-lede{max-width:none!important}.air-askwrap{max-width:none!important;width:100%!important}' +
    '.air-aspects{grid-template-columns:repeat(2,minmax(0,1fr))!important;column-gap:48px!important}' +
    '.air-aspects.bm-one-col{grid-template-columns:1fr!important}' +
    '.bm-foot-nolink{cursor:default;text-decoration:none!important;border:0!important;pointer-events:none}' +
    '.air{padding:16px 0!important}' +
    '.air-in{max-width:none!important;margin-left:0!important;margin-right:0!important}' +
    '.air-h{font-size:var(--bmo-h2-fs,30px)!important;line-height:var(--bmo-h2-lh,1.15)!important;letter-spacing:var(--bmo-h2-ls,normal)!important;font-weight:600!important;color:var(--bmo-ink,#141414)!important}' +
    '.augur-root,.air{--adv-stars-filled:var(--bm-yellow,#ffd100)!important;--adv-score-text:var(--bm-yellow,#ffd100)!important}' +
    '.air-num{color:var(--bm-yellow,#ffd100)!important}' +
    '.air-lede,.air-aspect{color:var(--bmo-text,#3b3a36)!important}' +
    '.air-num{font-size:40px!important;line-height:1!important}' +
    '.air-score-meta,.air-n{font-size:13px!important}.air-augur-meta{display:none!important}' +
    '.air-eyebrow{font-size:12px!important}' +
    '.air-lede{font-size:16px!important;line-height:1.5!important;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
    '.air-lede.bm-open{display:block;-webkit-line-clamp:unset;overflow:visible}' +
    '.air-aspects{margin-top:12px!important}' +
    '.air-aspect-h{font-size:14px!important;font-weight:600!important}' +
    '.air-aspect{padding:7px 0!important;font-size:14px!important;line-height:1.65!important}' +
    '.air-chips{display:none!important}' +
    '.air-askwrap{margin-top:14px!important}' +
    '.air-ask{min-height:44px!important;height:44px!important;font-size:14px!important}.air-ask input{font-size:14px!important}' +
    '.air-in{gap:28px!important}.air-augur{gap:16px!important}' +
    '.bm-or-mention{margin:-8px 0 0;font-size:13px;line-height:1.5;color:var(--bm-muted,#5e5b55)}.bm-or-mention a{color:inherit;text-decoration:underline}' +
    '.bm-more{display:block;align-self:flex-start;justify-self:start;margin:-4px 0 0;padding:0;border:0;background:none;font:inherit;font-size:14px;font-weight:600;text-decoration:underline;cursor:pointer;color:#141414}' +
    /* Widget Openreviews ≥ 28/10/2026 (bloc « hero » centré) : remis à gauche, note | texte, titre de section du site */
    '.air-feed,.air-hero{text-align:left!important}' +
    '.air-hero{display:grid!important;grid-template-columns:240px minmax(0,880px)!important;column-gap:72px!important;row-gap:14px!important;justify-items:start!important;align-items:start!important;max-width:none!important;margin:0!important;padding:0!important}' +
    '.air-hero>h2{grid-column:1/-1!important;justify-self:start!important;margin:0 0 6px!important;font-size:var(--bmo-h2-fs,30px)!important;line-height:var(--bmo-h2-lh,1.15)!important;letter-spacing:var(--bmo-h2-ls,normal)!important;font-weight:600!important;text-transform:none!important;color:var(--bmo-ink,#141414)!important;opacity:1!important}' +
    '.air-hero-score{grid-column:1!important;grid-row:2/span 4!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:8px!important;margin:0!important}' +
    '.air-hero-score .air-num{font-size:40px!important;line-height:1!important;color:var(--bm-yellow,#ffd100)!important}' +
    '.air-hero-count{font-size:13px!important;color:var(--bm-muted,#5e5b55)!important;margin:0!important}' +
    '.air-hero>.bm-or-mention,.air-hero-lede,.air-hero>.bm-more,.air-hero-actions{grid-column:2!important;justify-self:stretch!important;margin:0!important;text-align:left!important;max-width:none!important}' +
    '.air-hero-lede{font-size:16px!important;line-height:1.5!important;color:var(--bmo-text,#3b3a36)!important;display:-webkit-box!important;-webkit-line-clamp:3!important;-webkit-box-orient:vertical!important;overflow:hidden!important}' +
    '.air-hero-lede.bm-open{display:block!important;-webkit-line-clamp:unset!important;overflow:visible!important}' +
    '.air-hero>.bm-more{justify-self:start!important;margin-top:-6px!important}' +
    '.air-hero-actions{display:flex!important;justify-content:flex-start!important;margin-top:6px!important}' +
    '@media (max-width:767px){.air-num{font-size:32px!important}' +
    '.air-hero{grid-template-columns:1fr!important}.air-hero-score{grid-column:1!important;grid-row:auto!important;margin-bottom:6px!important}' +
    '.air-hero>.bm-or-mention,.air-hero-lede,.air-hero>.bm-more,.air-hero-actions{grid-column:1!important}' +
    '.air-hero-score .air-num{font-size:32px!important}.air-lede{font-size:15px!important}' +
    '.air-in{gap:18px!important}.air-score{gap:14px!important}.air-augur{margin-top:20px!important;padding-top:20px!important;gap:14px!important}' +
    '.air-aspects{gap:16px!important;grid-template-columns:1fr!important}.air-aspect{padding:6px 0!important}}';
  function tidyText(root) {
    /* Une seule liste (ex. « Points forts » sans « Points d'attention ») : pleine largeur, alignée sur le reste */
    var aspects = root.querySelector('.air-aspects');
    if (aspects) aspects.classList.toggle('bm-one-col', aspects.querySelectorAll('.air-aspect-col').length === 1);
    /* « Propulsé par OpenReviews » gardé en texte, sans lien sortant vers openreviews.io */
    root.querySelectorAll('.air-foot a.foot-link').forEach(function (a) {
      var span = document.createElement('span');
      span.className = 'foot-link bm-foot-nolink';
      span.setAttribute('aria-label', 'OpenReviews');
      while (a.firstChild) span.appendChild(a.firstChild);
      a.replaceWith(span);
    });
    var head = root.querySelector('.air-augur-head');
    var heroLede = root.querySelector('.air-hero-lede');
    if ((head || heroLede) && !root.querySelector('.bm-or-mention')) {
      var p = document.createElement('p');
      p.className = 'bm-or-mention';
      p.innerHTML = MENTION_HTML;
      if (head) head.after(p); else heroLede.before(p);
    }
    /* « 1500 avis » → « 1 500 avis » ; « Propulsé par » aligné sous la colonne de contenu */
    root.querySelectorAll('.air-n').forEach(function (el) {
      var t = el.textContent.trim();
      if (/^\d{4,}$/.test(t)) el.textContent = Number(t).toLocaleString('fr-FR');
    });
    var inner = root.querySelector('.air-in'), col = root.querySelector('.air-augur') || root.querySelector('.air-hero-lede');
    if (inner && col) {
      var off = Math.max(0, Math.round(col.getBoundingClientRect().left - inner.getBoundingClientRect().left));
      if (root.host) root.host.style.setProperty('--bmo-col', off + 'px');
    }
    root.querySelectorAll('a[href]').forEach(function (a) {
      if (a.hostname && a.hostname !== location.hostname && !/nofollow/.test(a.rel)) {
        a.rel = ((a.rel || '') + ' nofollow noopener noreferrer').trim();
      }
    });
    root.querySelectorAll('.air-eyebrow').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /Augur/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Synth[eè]se Augur/, 'Synthèse des avis').replace(/Augur/, 'des avis');
      });
    });
    root.querySelectorAll('.air-lede, .air-hero-lede').forEach(function (lede) {
      var next = lede.nextElementSibling;
      if (next && next.classList.contains('bm-more')) return;
      if (lede.scrollHeight <= lede.clientHeight + 2) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bm-more';
      b.textContent = 'Lire la suite';
      b.addEventListener('click', function () {
        var open = lede.classList.toggle('bm-open');
        b.textContent = open ? 'Réduire' : 'Lire la suite';
      });
      lede.after(b);
    });
  }
  /* Reprend sur la page la typographie des titres de section et la couleur du texte (variables héritées par le widget) */
  function syncType(host) {
    var h2 = null;
    document.querySelectorAll('main .shopify-section h2').forEach(function (h) {
      if (!h2 && h.offsetParent && !h.closest('.bm-or') && getComputedStyle(h).fontWeight >= 600) h2 = h;
    });
    if (h2) {
      var c = getComputedStyle(h2);
      host.style.setProperty('--bmo-h2-fs', c.fontSize);
      host.style.setProperty('--bmo-h2-lh', c.lineHeight);
      host.style.setProperty('--bmo-h2-ls', c.letterSpacing);
      host.style.setProperty('--bmo-ink', c.color);
    }
    var p = document.querySelector('.bm-buy p, main .rte p, main p');
    if (p) host.style.setProperty('--bmo-text', getComputedStyle(p).color);
  }
  var rz;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { document.querySelectorAll('.bm-or--feed [data-augur-host]').forEach(function (h) { syncType(h); if (h.shadowRoot) tidyText(h.shadowRoot); }); }, 150);
  });

  function tidyFeed() {
    document.querySelectorAll('.bm-or--feed [data-augur-host]').forEach(function (host) {
      var sr = host.shadowRoot;
      if (!sr || sr.__bmTidy) return;
      sr.__bmTidy = true;
      syncType(host);
      var st = document.createElement('style');
      st.textContent = FEED_CSS;
      sr.appendChild(st);
      tidyText(sr);
      var t2;
      new MutationObserver(function () {
        clearTimeout(t2);
        t2 = setTimeout(function () { if (!st.isConnected) sr.appendChild(st); tidyText(sr); }, 50);
      }).observe(sr, { childList: true, subtree: true });
    });
  }

  /* Avis du bas : section masquée sous MIN_FEED avis (1) ou quand il n'y a que
     des notes sans synthèse ni avis écrit (ex. matelas La Redoute 6 notes : bloc presque vide ; la note du haut reste, non cliquable) */
  function gateFeed() {
    document.querySelectorAll('.bm-or--feed:not([data-bm-or-gate])').forEach(function (feed) {
      feed.setAttribute('data-bm-or-gate', '');
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var pidEl = document.querySelector('[data-bm-or="stars"][data-pid]');
      var pid = (pidEl && pidEl.getAttribute('data-pid')) || (meta && meta.id);
      if (!pid) return;
      productRating(pid).then(function (r) {
        if (r.n >= MIN_FEED && r.detail) return;
        var sec = feed.closest('.shopify-section') || feed;
        sec.style.display = 'none';
      });
    });
  }

  function scan() {
    gateFeed();
    tidyFeed();
    document.querySelectorAll('[data-bm-or]:not([data-bm-or-done])').forEach(function (el) {
      el.setAttribute('data-bm-or-done', '');
      var v = el.getAttribute('data-bm-or');
      var pid = el.getAttribute('data-pid');
      var p = v === 'stars' && pid ? productRating(pid) : shopRating();
      p.then(function (r) {
        if (!(r.n >= MIN_REVIEWS)) return trustpilot(el);
        if (v === 'stars') stars(el, r); else headerLine(el);
      });
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.bm-orstars{display:inline-flex;align-items:center;gap:6px;padding:0;margin:0;border:0;background:none;cursor:pointer;font:inherit;font-size:14px;line-height:20px;color:var(--bm-ink,#141414)}' +
    '.bm-orstars:hover .bm-orstars__c{text-decoration:underline}.bm-orstars--static{cursor:default}.bm-orstars--static:hover .bm-orstars__c{text-decoration:none}' +
    '.bm-orstars__s{position:relative;display:inline-block;font-size:18px;letter-spacing:1px;color:var(--bm-line,#ece8df)}' +
    '.bm-orstars__s::before{content:"\\2605\\2605\\2605\\2605\\2605"}' +
    '.bm-orstars__s>span{position:absolute;inset:0 auto 0 0;overflow:hidden;white-space:nowrap;color:var(--bm-yellow,#ffd100)}' +
    '.bm-orstars__s>span::before{content:"\\2605\\2605\\2605\\2605\\2605"}' +
    '.bm-orstars__n{font-weight:600}' +
    '.bm-orstars__c{color:var(--bm-muted,#5e5b55)}' +
    '.bm-orstars-wrap{position:relative;display:inline-flex;align-items:center;gap:6px}' +
    '.bm-orstars__info{width:18px;height:18px;padding:0;border:1px solid var(--bm-muted,#5e5b55);border-radius:50%;background:none;color:var(--bm-muted,#5e5b55);font:600 11px/16px var(--bm-font,inherit);font-style:italic;text-align:center;cursor:pointer;flex:none}' +
    '.bm-orstars__info:hover,.bm-orstars__info:focus-visible{border-color:var(--bm-ink,#141414);color:var(--bm-ink,#141414)}' +
    '.bm-orstars__tip{display:none;position:absolute;top:calc(100% + 8px);left:0;z-index:30;width:min(320px,calc(100vw - 40px));padding:12px 14px;border-radius:10px;background:#fff;border:1px solid var(--bm-line,#ece8df);box-shadow:0 8px 24px rgba(20,20,20,.12);font-size:13px;line-height:1.5;color:var(--bm-ink,#141414);text-align:left;white-space:normal}' +
    '.bm-orstars__tip a{text-decoration:underline;color:inherit}' +
    '.bm-orstars-wrap.is-open .bm-orstars__tip{display:block}' +
    '@media (hover:hover){.bm-orstars__info:hover~.bm-orstars__tip,.bm-orstars__tip:hover{display:block}}';
  document.head.appendChild(css);

  window.__bmOr = scan;
  scan();
  /* tiroir panier et sections rechargées en AJAX */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); })
    .observe(document.body, { childList: true, subtree: true });
})();
